import Check from '../Check';
import Report from '../Report';
import { MessageType } from '../Message';
import type { IObjectType } from '../../../stores/model/metamodel/object_type';

class ObjectInheritanceCheck extends Check<IObjectType> {
  static description = 'Check object inheritance';

  check(): Report {
    this.report = new Report();

    if (this.element.abstract && this.element.inheritancesAsSupertype.length === 0) {
      this.report.addMessage(
        MessageType.WARNING,
        `Object ${this.element.asString()} is abstract but has no subtypes`,
        this,
        this.element
      );
    } else {
      this.report.addMessage(
        MessageType.INFORMATION,
        'Inheritance checks completed successfully',
        this,
        this.element
      );
    }

    return this.report;
  }
}

export default ObjectInheritanceCheck;
